module.exports = __webpack_public_path__ + "static/media/sbom-slide-5.93f44d54.jpg";